<template>
  <div>
    <AddStApplicant
      v-if="loaded"
      :add-statement="addStatement"
      :title="RouteText.ALTERNATIVE_SERVICE_REFUSAL"
      @save="sendPackage"
    >
      <template #footer="{ next, isSaveLoading }">
        <RefusalFooter
          @btn-click="next"
          :loading="isSaveLoading || isSendLoading"
        />
      </template>
    </AddStApplicant>

    <SkeletonLoader v-if="loading" />
    <SignatureComponent />
  </div>
</template>

<script>
import { RouteText } from '@/router';
import SkeletonLoader from '@/components/base/SkeletonLoader';
import { BreadCrumbsModule } from '@/store/modules/breadCrumbs';
import SignatureComponent from '@/components/base/SignatureComponent';
import { ServicesModule } from '@/store/modules/services';
import { AddStModule } from '@/store/modules/alternativeServices/additionalStatement';
import { Role } from '@/utils/dictionaries';
import cloneDeep from 'clone-deep';
import { FieldGroup } from '@/utils/fullStatementView';
import RefusalFooter from './RefusalFooter';
import AddStApplicant from '@/views/alternativeServices/AddStApplicant/AddStApplicant';
import { getAddStatementBreadcrumbs } from '@/utils/common';

export default {
  name: 'AltRefusal',
  props: {
    parentStatementId: {
      type: String,
      required: true,
    },
  },
  components: {
    RefusalFooter,
    SkeletonLoader,
    SignatureComponent,
    AddStApplicant,
  },
  data() {
    return {
      FieldGroup,
      Role,
      RouteText,
    };
  },
  computed: {
    addStatement() {
      return AddStModule.createDraftState.entity;
    },

    role() {
      if (this.addStatement.applicant.person) return Role.PERSON;
      if (this.addStatement.applicant.organization) return Role.ORGANIZATION;
      if (this.addStatement.applicant.foreignOrganization)
        return Role.FOREIGN_ORGANIZATION;

      return null;
    },

    loading() {
      return AddStModule.createDraftState.loading;
    },

    loaded() {
      return AddStModule.createDraftState.loaded;
    },

    isSendLoading() {
      return (
        AddStModule.stXmlBase64.loading || AddStModule.sendPackageState.loading
      );
    },
  },
  async created() {
    this.setBreadcrumbs();

    await AddStModule.createDraft({
      originalStatementId: this.parentStatementId,
      addStatementType: 'WITHDRAWAL',
    });
  },
  methods: {
    setBreadcrumbs() {
      const addStatementBreadcrumbs = getAddStatementBreadcrumbs(
        this.parentStatementId
      );

      addStatementBreadcrumbs.path.push({
        text: RouteText.ALTERNATIVE_SERVICE_REFUSAL,
        disabled: true,
      });

      BreadCrumbsModule.SET(addStatementBreadcrumbs);
    },

    async sendPackage(addStatement) {
      try {
        await AddStModule.getStXmlBase64(addStatement.id);

        const dataBase64 = AddStModule.stXmlBase64.entity;
        const runSignProps = [
          { xmlSigBase64: dataBase64 },
          this.getDataUserCertificate(addStatement.applicant),
        ];

        // подписываем XmlBase64 и получаем подпись в Base64
        const signs = await ServicesModule.runSign(...runSignProps);

        await AddStModule.sendPackage({
          addStatementId: addStatement.id,
          xmlSigBase64: signs.xmlSigBase64[0],
        });

        this.$router.go(-1);
      } catch (error) {
        await this.$vuetify.goTo('#header-target', { duration: 200 });
        throw error;
      }
    },

    getDataUserCertificate(applicant) {
      const subject = cloneDeep(applicant);

      subject.trustee = applicant[this.role].trusteeInfo;
      subject.assignee = applicant[this.role].assignee;

      return subject;
    },
  },
};
</script>
